export enum TrainingExerciseState {
  Open,
  Failed,
  Succeeded,
}
